import { render, staticRenderFns } from "./AvailableLicenses.vue?vue&type=template&id=b48d69b4&scoped=true"
import script from "./AvailableLicenses.vue?vue&type=script&lang=js"
export * from "./AvailableLicenses.vue?vue&type=script&lang=js"
import style0 from "./AvailableLicenses.vue?vue&type=style&index=0&id=b48d69b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48d69b4",
  null
  
)

export default component.exports